// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"PageHeader_PageHeader__f_ki9","ExtraContainer":"PageHeader_ExtraContainer__WVnQ0","SwitchElement":"PageHeader_SwitchElement__13eAz"};